import { GridCellParams } from '@mui/x-data-grid-pro';
import { isRowInEditMode } from 'features/Orders/OrderWorkunits/helpersOrderWorkunits';
/* import OrderAffectationScopeCell from 'features/Orders/OrderWorkunits
/OrderWorkunitsDataGrids/Cells/DataGridScopeCell/OrderAffectationScopeCell'; */
import PurchaseOrderCell from 'features/Orders/OrderWorkunits/OrderWorkunitsDataGrids/Cells/PurchaseOrderCell/PurchaseOrderCell';
import React from 'react';
import { useSelector } from 'store/hooks';
/* import { formatDateToddMMYYY } from 'helpers/format'; */
import { SelectedWorkunit } from 'types/entities/SelectedWorkunit';
import PurchaseOrders from 'types/entities/PurchaseOrders';

export default function OrderGridPoCell(props: { params: GridCellParams<any, SelectedWorkunit, any> }) {
  const { params } = props;
  const poList = useSelector((state) => state.purchaseOrder?.datas);

  const filteredItem: PurchaseOrders | undefined = poList?.find((item) => params.row?.po_name?.id === item.id);

  const activeEditRowIds = useSelector((state) => state.catalogToOrder.selectedWorkunitsEditIds);
  if (isRowInEditMode(activeEditRowIds, params.row.randomId)) {
    return <PurchaseOrderCell row={params.row as SelectedWorkunit} cellType="selected" />;
  }

  return <>{filteredItem?.reference || params.row?.po_name?.name}</>;
}
